export enum ActionType {
  'EDIT',
  'DELETE'
}

export enum RemoveType {
  'PERSONAL_SAVED_SEARCH',
  'SHARE_SAVED_SEARCH'
}
